import React from 'react';
import { Layout } from '../components/layout/Layout';
import { ComicHeading } from '../components/ComicPanel';

const Privacy = () => {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <ComicHeading as="h1" className="text-4xl mb-8" data-testid="privacy-title">
          Privacy Policy
        </ComicHeading>

        <div className="prose prose-invert prose-slate max-w-none">
          <p className="text-slate-300 mb-6">
            Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>

          <section className="mb-8">
            <h2 className="text-yellow-500 uppercase font-bold tracking-widest text-xl mb-4">
              Information We Collect
            </h2>
            <p className="text-slate-300 mb-4">
              When you create an account, we collect:
            </p>
            <ul className="list-disc list-inside text-slate-300 space-y-2">
              <li>Email address (for account authentication and communication)</li>
              <li>Password (stored securely using industry-standard hashing)</li>
              <li>Account preferences (such as email notification settings)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-yellow-500 uppercase font-bold tracking-widest text-xl mb-4">
              How We Use Your Information
            </h2>
            <ul className="list-disc list-inside text-slate-300 space-y-2">
              <li>To provide access to members-only content</li>
              <li>To send account-related emails (verification, password reset)</li>
              <li>To send content updates (only if you opt in)</li>
              <li>To improve our services</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-yellow-500 uppercase font-bold tracking-widest text-xl mb-4">
              Data Security
            </h2>
            <p className="text-slate-300">
              We implement appropriate security measures to protect your personal information. 
              Passwords are hashed using bcrypt. All data transmission is encrypted using HTTPS.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-yellow-500 uppercase font-bold tracking-widest text-xl mb-4">
              Your Rights
            </h2>
            <p className="text-slate-300 mb-4">You have the right to:</p>
            <ul className="list-disc list-inside text-slate-300 space-y-2">
              <li>Access your personal data</li>
              <li>Update or correct your information</li>
              <li>Delete your account</li>
              <li>Opt out of marketing communications</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-yellow-500 uppercase font-bold tracking-widest text-xl mb-4">
              Cookies
            </h2>
            <p className="text-slate-300">
              We use essential cookies for authentication purposes. We do not use tracking 
              cookies or third-party analytics that track your browsing behavior.
            </p>
          </section>

          <section>
            <h2 className="text-yellow-500 uppercase font-bold tracking-widest text-xl mb-4">
              Contact
            </h2>
            <p className="text-slate-300">
              For privacy-related questions, contact us at{' '}
              <a href="mailto:privacy@porkcops.com" className="text-yellow-500 hover:text-yellow-400">
                privacy@porkcops.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default Privacy;
